import React from 'react'
import ReactDOM from "react-dom/client";
import App from './App'
import "./locales/i18n";

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App/>)
